import { apiClient } from 'services/api-client';

export const getGaMetrics = async (companyKey) => {
  return await apiClient.get(`/gap-analysis/metrics?companyKey=${companyKey}`);
};

export const getFrameworks = async () => {
  return await apiClient.get(`/frameworks`);
};

export const getFrameworksInUse = async (companyId) => {
  return await apiClient.get(`/frameworks/in-use?companyId=${companyId}`);
};

export const getControlsGrouped = async (frameworksIds) => {
  const queryString = frameworksIds.join(",");
  return await apiClient.get(`/controls-framework/controls-grouped?frameworksIds=${queryString}`);
};

export const getGapAnalysisControl = async (idGap, idControl) => {
  return await apiClient.get(`/gap-analysis/${idGap}/controls-framework/${idControl}`);
}

// gapanalysis_id: the Gap Analysis / Compliance Program the change is being made from — a shared
// control has no single owner, so the backend needs it to record which module the change came
// from in the audit log (same param the GET /gap-analysis/control/:id call already sends).
export const updateMaturityLevel = async (idControl, maturityLevel, gapanalysis_id) => {
  return await apiClient.put(`/gap-analysis/control/${idControl}/maturity`, { maturityLevel, }, { params: { gapanalysis_id } });
};

export const updateStatusControl = async (idControl, status, gapanalysis_id) => {
  return await apiClient.put(`/gap-analysis/control/${idControl}/status`, { status, }, { params: { gapanalysis_id } });
};

export const updateStatusObjectiveControl = async (idObjective, objective) => {
  return await apiClient.put(`/gap-analysis/objective/${idObjective}/status`, { objective });
};


export const postGapAnalysis  = async (data) => {
  return await apiClient.post(`/gap-analysis`, data);
};

export const getGapAnalysis = async (tenant) => {
  return await apiClient.get(`/gap-analysis?companyKey=${tenant}`)
}

export const getGapAnalysisDetails = async (id) => {
  return await apiClient.get(`/gap-analysis/${id}/controls`)
}

export const getGapAnalysisControlsDetails = async (id) => {
  return await apiClient.get(`/gap-analysis/${id}/controls-framework`)
}

export const getGapAnalysisControlDetails = async (id, gapanalysis_id) => {
  return await apiClient.get(`/gap-analysis/control/${id}`, { params: { gapanalysis_id } })
}

export const postGapAnalysisVinculo = async (id, data) => {
  return await apiClient.post(`/gap-analysis/${id}/vinculo`, data);
};

export const deleteGapAnalysisVinculo = async (id_vinculo, gapanalysis_id) => {
  return await apiClient.delete(`/gap-analysis/vinculo/${id_vinculo}`, { params: { gapanalysis_id } });
};

export const getGapAnalysisDashboard = async (id) => {
  return await apiClient.get(`/gap-analysis/${id}/dashboard`);
};

export const postGapAnalysisReport = async (data) => {
  return await apiClient.post(`/gap-analysis/report`, data);
};

export const getGapAnalysisReport = async (id) => {
  return await apiClient.get(`/gap-analysis/report?companyKey=${id}`)
}

export const deleteGapAnalysisReport = async (id) => {
  return await apiClient.delete(`/gap-analysis/report/${id}`);
};

export const getGapAnalysisReportByID = async (id) => {
  return await apiClient.get(`/gap-analysis/report/${id}`)
}
